import { CustomerPartnerFunctions, partnersDiverge } from './customerTypes';

function PartnerChip({ code, reference }: { code: string; reference: string }) {
  return (
    <span className='inline-flex items-center gap-1 rounded-md bg-gray-100 px-1.5 py-0.5 text-xs text-gray-600'>
      <span className='font-semibold text-gray-400'>{code}</span>
      <span className='text-gray-700'>{reference}</span>
    </span>
  );
}

export function PartnerChips({
  partners,
}: {
  partners: CustomerPartnerFunctions;
}) {
  const diverge = partnersDiverge(partners);
  return (
    <div className='flex items-center gap-1.5'>
      <PartnerChip code='P' reference={partners.payerRef} />
      <PartnerChip code='B' reference={partners.billToRef} />
      {diverge && (
        <span
          title='Payer and bill-to differ'
          className='inline-flex h-5 w-5 items-center justify-center rounded-full bg-amber-50 text-xs font-semibold text-amber-700'
        >
          ≠
        </span>
      )}
    </div>
  );
}
